import { Attachment, GeoLocation } from "./shared.types";
import { User } from "./user.types";

export enum EventType {
  DATE_NIGHT = "date-night",
  AFFAIR = "affair",
}

export enum EventStatus {
  ACTIVE = "active",
  CANCELLED = "cancelled",
}

export type Event = {
  id: string;
  type: EventType;
  title: string;
  description: string;
  location: GeoLocation;
  creator: User;
  participants: User[];
  participantsCount: number;
  isExpired: boolean;
  createdAt: string;
  expiresAt: string;
  status: EventStatus;
  date?: string;
  photos?: Attachment[];
  startDate?: string;
  endDate?: string;
  capacity?: number;
};
